import { render, staticRenderFns } from "./headerDesign.vue?vue&type=template&id=2a10dd72&scoped=true"
import script from "./headerDesign.vue?vue&type=script&lang=js"
export * from "./headerDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a10dd72",
  null
  
)

export default component.exports